export class ShippingSequanceData {

    employeeCode: string;
    seqNo: number;
    transactionNo: string;
    actualSeqNo: number;
    fromLocationName: string;
    fromLongitude: number;
    fromLatitude: number;
    toLocationName: string;
    toLongitude: number;
    toLatitude: number;

    fromLocCode: string;
    toLocCode: string;

}
